<template>
  <div>
    <a-textarea placeholder="请输入会员协议内容" :rows="10" v-model="formInline.agreement" />
  <p style="margin-top: 10px;">
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button @click="handleCancel">清空</a-button>
  </p>
  </div>
</template>

<script>
import { addAgreement,getAgreement } from "@/api/admin.js";
import { message } from "ant-design-vue";

export default {
  components: {
    
  },
  data() {
    return {
      formInline: {
        agreement: "",
      },
    
    };

  },
  mounted() {
    this.get();
  },
  methods:{
    handleOk(){
        this.loading = true;
        console.log("提交数据：",this.formInline);
        addAgreement(this.formInline).then(res => {
          if (res.success) {
            message.success(res.info);
            this.get();
          } else {
            message.error(res.info);
          }
        });
        this.loading = false;
        
    },
    handleCancel(){
      this.formInline.agreement = ""
    },
    async get() {
      const res = await getAgreement();
      if (res.success && res.data) {
        this.formInline = res.data[0];
      }else{
        message.error("获取会员协议内容失败");
      }
    },

  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/membershipAgreement/membershipAgreementContent.vue